var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionLoadingTopBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 320,
    viewBox: "0 0 375 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9862_162963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 320
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 320,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9862_162963)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-68.3589 84.6165C-37.5346 127.856 -29.6736 205.747 73.6411 199.2C176.956 192.654 160.728 137.192 212.817 155.348C264.906 173.504 339.607 244.423 379.622 206.867C419.636 169.311 529.143 222.799 540.031 236.488C550.919 250.177 600.02 194.885 586.213 155.348C572.407 115.811 569.488 -3.84455 569.488 -3.84455L-86.1033 -31.6444C-86.1033 -31.6444 -99.1831 41.3769 -68.3589 84.6165Z",
    fill: "url(#paint0_linear_9862_162963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.672317,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-176.884 64.6362C-142.118 90.7423 -19.4616 158.845 83.9145 84.6164C187.291 10.3881 268.708 83.2117 349.26 64.6362C429.812 46.0606 489.425 61.1493 528.789 58.1278C568.153 55.1063 691.693 15.6173 570.381 -14.6013C449.069 -44.8198 -165.557 -92.9845 -165.557 -92.9845C-165.557 -92.9845 -211.651 38.53 -176.884 64.6362Z",
    fill: "url(#paint1_linear_9862_162963)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9862_162963",
    x1: -18.6813,
    y1: 29.5197,
    x2: -15.2034,
    y2: 243.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509739,
    stopColor: "#CFE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9862_162963",
    x1: -144.432,
    y1: -106.148,
    x2: -167.51,
    y2: 78.4443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96BFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243454,
    stopColor: "#AFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACFDFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionLoadingTopBackground);
export default __webpack_public_path__ + "static/media/transaction-loading-top-background.c5d9a20fb98cf597311e82a6b062ab9c.svg";
export { ForwardRef as ReactComponent };